module.exports = __webpack_public_path__ + "img/image-04.0be7b9b7.jpeg";